import { getServerDate } from "./serverTimeHelpers";

export const WORK_START_PROMPT_DISMISSED_KEY = "workStartPromptDismissedDate";

export const getTodayDateKey = (date = null) => {
  const source = date || getServerDate();
  const year = source.getFullYear();
  const month = String(source.getMonth() + 1).padStart(2, "0");
  const day = String(source.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const isWorkStartPromptDismissedToday = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return false;
  }

  return (
    localStorage.getItem(WORK_START_PROMPT_DISMISSED_KEY) === getTodayDateKey()
  );
};

export const dismissWorkStartPromptForToday = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }

  localStorage.setItem(WORK_START_PROMPT_DISMISSED_KEY, getTodayDateKey());
};
